import { type AlertDialogDescriptionProps, AlertDialog as BaseAlertDialog } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { descriptionStyle } from './AlertDialog.css';

type Props = AlertDialogDescriptionProps;

export const AlertDialogDescription = ({ children, ...delegated }: Props) => {
  return (
    <BaseAlertDialog.Description {...delegated} className={clsxs(descriptionStyle, delegated.className)}>
      {children}
    </BaseAlertDialog.Description>
  );
};
